import clsx from 'clsx';
import { chip, chipOn, chipOff } from './ui';

interface CategoryTabsProps {
  categories: Record<string, number>;
  selected: string;
  onChange: (category: string) => void;
}

export const CATEGORY_LABELS: Record<string, string> = {
  road_race: '路跑',
  trail: '越野',
  marathon: '馬拉松',
  tour: '進香',
  other: '其他',
};

const ORDER = ['road_race', 'marathon', 'trail', 'tour', 'other'];

export default function CategoryTabs({ categories, selected, onChange }: CategoryTabsProps) {
  const ids = ORDER.filter((id) => (categories[id] || 0) > 0);
  const total = Object.values(categories).reduce((a, b) => a + b, 0);

  return (
    <div role="group" aria-label="活動類型" className="flex gap-2 overflow-x-auto scrollbar-hide -mx-5 px-5">
      <button
        type="button"
        onClick={() => onChange('all')}
        aria-pressed={selected === 'all'}
        className={clsx(chip, selected === 'all' ? chipOn : chipOff)}
      >
        全部{total > 0 && <span className="tabular opacity-70">{total}</span>}
      </button>
      {ids.map((id) => (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          aria-pressed={selected === id}
          className={clsx(chip, selected === id ? chipOn : chipOff)}
        >
          {CATEGORY_LABELS[id] || id}
          <span className="tabular opacity-70">{categories[id]}</span>
        </button>
      ))}
    </div>
  );
}
